
import { Link } from "react-router-dom";
import QuestionOtherActions from "./QuestionOtherActions";

export default function QuestionContent({ discussion }) {
	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<div>
				<Link to={`/profile/${discussion.profile_detail?.id}/`}>
					<div className="flex flex-row items-center">
						{discussion.profile_detail?.avatar_url && (
							<>
								<div className="w-[40px] aspect-square">
									<img
										src={discussion.profile_detail?.avatar_url}
										alt=""
										className="w-full h-full object-cover rounded-full"
									/>
								</div>
								<div className="spacer p-[5px]"></div>
							</>
						)}
						<div className="font-Vazir-400 text-[14px] text-[#666666]">{discussion.profile_detail?.name}</div>
					</div>
				</Link>
			</div>
			<div className="spacer p-[10px]"></div>
			<div className="font-Vazir-700 text-[16px] text-midGray">{discussion.title}</div>
			<div className="spacer p-[10px]"></div>
			<div className="font-Vazir-300 text-[14px] text-darkBlue">{discussion.text}</div>
			<>
				<QuestionOtherActions discussion={discussion} />
				<div className="spacer p-[2px]"></div>
			</>
		</div>
	)
}
